// Module
var code = `<link href="css/editable-content.css?v=3.1.0-RC3" rel="stylesheet"/> <div ng-attr-contenteditable="{{!ngDisabled}}" ng-attr-disabled="{{ngDisabled ? true : undefined}}" placeholder="{{placeholder}}" guide-selector="contenteditable" class="contenteditable"> </div> `;
// Exports
export default code;